import { cancelBookingApi, assignTripApi, getNewBookingsApi, getCancelReasonApi, autoAssignTripApi, getAvailableCabsRadiusApi, getSelectedCabApi } from "../../utils/booking/NewBooking";
import { call, put, takeLatest, all } from "redux-saga/effects";
import { autoAssignTripFailure, autoAssignTripSuccess, getAvailableCabsRadiusFailure, getAvailableCabsRadiusSuccess, getSelectedCabFailure, getSelectedCabSuccess, updateNewBookingFailure, updateNewBookingSuccess } from "../actions/newAction";
import api from "../../utils/axios";

function* cancelBookingSaga(action: any): any {
    try {
        const response = yield call(cancelBookingApi, action.payload);
        const result = response.data;

        if (result?.status !== 200) {
            yield put({ type: "CANCEL_BOOKING_FAILURE", payload: result?.message || "Failed to cancel booking" });
            return;
        }
        yield put({ type: "CANCEL_BOOKING_SUCCESS", payload: result });
    } catch (error: any) {
        yield put({ type: "CANCEL_BOOKING_FAILURE", payload: error.response?.data?.message || "Failed to cancel booking" });
    }
}

function* assignTripSaga(action: any): any {
    try {
        const response = yield call(assignTripApi, action.payload);
        const result = response.data?.data?.[0] || response.data;

        if (result?.status !== 200) {
            yield put({ type: "ASSIGN_TRIP_FAILURE", payload: result?.message || "Failed to assign trip" });
            return;
        }
        yield put({ type: "ASSIGN_TRIP_SUCCESS", payload: result });
    } catch (error: any) {
        yield put({ type: "ASSIGN_TRIP_FAILURE", payload: error.response?.data?.message || "Failed to assign trip" });
    }
}
export function* watchCancelBooking() {
    yield takeLatest(
        "CANCEL_BOOKING_REQUEST",
        cancelBookingSaga
    );
}

export function* watchAssignTrip() {
    yield takeLatest(
        "ASSIGN_TRIP_REQUEST",
        assignTripSaga
    );
}

function* getNewBookingsSaga(action: any): any {
    try {
        const response = yield call(getNewBookingsApi, action.payload);

        const raw = response.data?.data?.data || [];
        const todaycount = response.data?.data?.todaycount !== undefined
            ? response.data.data.todaycount
            : (response.data?.todaycount !== undefined ? response.data.todaycount : 0);

        yield put({
            type: "GET_NEW_BOOKINGS_SUCCESS",
            payload: {
                bookings: Array.isArray(raw) ? raw : [],
                todaycount: Number(todaycount) || 0,
            },
        });
    } catch (error: any) {
        yield put({
            type: "GET_NEW_BOOKINGS_FAILURE",
            payload: error.response?.data?.message || "Failed to fetch new bookings",
        });
    }
}

function* getCancelReasonSaga(action: any): any {
    try {
        const response = yield call(getCancelReasonApi, action.payload);
        //console.log("[getCancelReasonSaga] raw response:", response.data);
        const payload =
            Array.isArray(response.data) ? response.data
                : Array.isArray(response.data?.data) ? response.data.data
                    : Array.isArray(response.data?.data?.data) ? response.data.data.data
                        : [];

        //console.log("[getCancelReasonSaga] parsed payload:", payload);
        yield put({
            type: "GET_CANCEL_REASON_SUCCESS",
            payload,
        });
    } catch (error: any) {
        //console.error("[getCancelReasonSaga] error:", error);
        yield put({
            type: "GET_CANCEL_REASON_FAILURE",
            payload: error.response?.data?.message || "Failed to fetch cancel reasons",
        });
    }
}

function* updateNewBookingSaga(action: any): Generator<any, void, any> {
    try {
        const {
            iscv, istollgate, isgst, isrefferal = false,
            isadditionalfare = false, noofvechicles = 1,
            ...bodyData
        } = action.payload;

        const queryParams = `?iscv=${iscv}&istollgate=${istollgate}&isgst=${isgst}&isrefferal=${isrefferal}&isadditionalfare=${isadditionalfare}&noofvechicles=${noofvechicles}`;

        const response = yield call(api.post, `/booking/editbooking${queryParams}`, bodyData);

        yield put(updateNewBookingSuccess(response.data));
    } catch (error: any) {
        yield put(updateNewBookingFailure(error?.response?.data?.message || "Update failed"));
    }
}

function* handleAutoAssignTrip(action: any): Generator<any, void, any> {
    try {
        const response = yield call(autoAssignTripApi, action.payload);
        const { status, message: msg, data } = response.data;

        if (status === 200 && data) {
            yield put(autoAssignTripSuccess(data));
        } else if (status === 200 && !data) {
            yield put(autoAssignTripFailure(msg || "No cabs available"));
        } else {
            yield put(autoAssignTripFailure(msg || "Auto-assign failed"));
        }
    } catch (error: any) {
        const errMsg =
            error?.response?.data?.message || "Something went wrong during auto-assign";
        yield put(autoAssignTripFailure(errMsg));
    }
}

function* getAvailableCabsRadiusSaga(action: any): any {
    try {
        const response = yield call(
            getAvailableCabsRadiusApi,
            action.payload.branchid,
            action.payload.vehicletype,
            action.payload.fromlat,
            action.payload.fromlong
        );

        const { status, message, data } = response.data;

        if (status === 200 && data?.data) {
            yield put(getAvailableCabsRadiusSuccess(data.data));
        } else {
            yield put(
                getAvailableCabsRadiusFailure(""
                    // message || "No cabs available"
                )
            );
        }
    } catch (error: any) {
        yield put(
            getAvailableCabsRadiusFailure(
                error?.response?.data?.message ||
                "Failed to fetch available cabs"
            )
        );
    }
}

function* getSelectedCabSaga(action: any): any {
    try {
        const { cabid, fromlat, fromlong } = action.payload;

        const response = yield call(
            getSelectedCabApi,
            cabid,
            fromlat,
            fromlong
        );

        yield put(getSelectedCabSuccess(response.data.data.data));
    } catch (error: any) {
        yield put(
            getSelectedCabFailure(
                error.response?.data?.message || error.message
            )
        );
    }
}


export function* watchGetCancelReason() {
    yield takeLatest("GET_CANCEL_REASON_REQUEST", getCancelReasonSaga);
}

function* watchUpdateNewBooking() {
    yield takeLatest("UPDATE_NEW_BOOKING_REQUEST", updateNewBookingSaga);
}
function* watchAutoAssign() {
    yield takeLatest("AUTO_ASSIGN_TRIP_REQUEST", handleAutoAssignTrip);
}
function* watchGetAvailableCabsRadius() {
    yield takeLatest(
        "GET_AVAILABLE_CABS_RADIUS_REQUEST",
        getAvailableCabsRadiusSaga
    );
}
function* watchGetSelectedCab() {
    yield takeLatest("GET_SELECTED_CAB_REQUEST", getSelectedCabSaga);
}

// takeLatest, like every other watcher here. The New page dispatches this from
// a dozen places - mount, socket events, tab focus, and after each
// assign/cancel/update - so several are regularly in flight at once. Under
// takeEvery each one issued its own request and whichever landed last won,
// which let a stale response overwrite a fresher list.
export function* watchGetNewBookings() {
    yield takeLatest("GET_NEW_BOOKINGS_REQUEST", getNewBookingsSaga);
}


export default function* newBookingSaga() {
    yield all([
        watchCancelBooking(),
        watchAssignTrip(),
        watchGetNewBookings(),
        watchGetCancelReason(),
        watchUpdateNewBooking(),
        watchAutoAssign(),
        watchGetAvailableCabsRadius(),
        watchGetSelectedCab(),
    ]);
}
